import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addTv,
  memberGet,
  memberGetKey,
  updateTv,
  userGet,
} from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { tvSchema } from "../../schema/tvSchema";
import useGymsData from "../../hooks/useGymsData";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { useGetFetch } from "../../data/Queries";
import "./tv.css";

const TvUpdateForm = ({
  initialValues,
  isEdit,
  closeModal,
  token,
  getTvData,
}) => {
  const dispatch = useDispatch();
  const [memberFilters, setMemberFilters] = useState({
    limit: "10",
    is_tv: 1,
    gym_id: initialValues?.gym_id || "",
  });
  const [isPage, setIsPage] = useState(0);

  const {
    data: gymsData,
    isLoading: isLoadingGyms,
    isFetching: isFetchingGyms,
  } = useGymsData();

  const {
    data: membersData,
    isLoading: isLoadingMembersData,
    isFetching: isFetchingMembersData,
    refetch: refetchMembersData,
  } = useGetFetch({
    url: userGet,
    key: memberGetKey,
    filters: memberFilters,
    isPage: isPage + 1,
    token,
  });

  console.log("memberFilters", memberFilters);

  useEffect(() => {
    refetchMembersData();
  }, [memberFilters]);

  const memberOptions =
    membersData?.data.map((member) => ({
      label: member?.name,
      value: member?.uid,
    })) || [];

  console.log("initialValues", initialValues);

  const formik = useFormik({
    initialValues: initialValues
      ? {
          tv_name: initialValues.tv_name,
          tv_user_id: initialValues.tv_user_id || "",
          gym_id: initialValues.gym_id || "",
        }
      : {
          tv_name: "",
          tv_user_id: "",
          gym_id: "",
        },
    validationSchema: tvSchema,
    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit ? updateTv : addTv;

      // console.log("values===>", values);

      const payload = {
        tv_name: values?.tv_name,
        tv_user_id: values?.tv_user_id,
        gym_id: values?.gym_id,
        uid: initialValues?.uid,
      };

      // console.log("payload is", payload);

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("result is==>", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getTvData();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  // console.log("Current Form Values:", formik.values);
  // console.log("formik Errors:", formik.errors);

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title={isEdit ? "Edit TV" : "Add TV"}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Save"}
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label>
              TV Name
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <input
                type="text"
                name="tv_name"
                // className=""
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "10px",
                  fontWeight: "500",
                }}
                placeholder="TV Name"
                value={formik.values.tv_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.tv_name && formik.errors.tv_name ? (
              <div className="error-message">{formik.errors.tv_name}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              Select Gym
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <SelectDropdownLabel
                name="Select Gym"
                options={gymsData || []}
                value={gymsData.find(
                  (option) => option.value === formik.values.gym_id
                )}
                setSelectedOption={(selectedOption) => {
                  formik.setFieldValue("gym_id", selectedOption?.value);
                  setMemberFilters((prev) => ({
                    ...prev,
                    gym_id: selectedOption?.value,
                  }));
                }}
              />
            </div>

            {formik.touched.gym_id && formik.errors.gym_id ? (
              <div className="error-message">{formik.errors.gym_id}</div>
            ) : null}
          </div>

          {formik.values.gym_id && (
            <div className="formInputBox">
              <label>
                Select User
                <span className="text-danger">*</span>
              </label>
              <div className="commonWrapper dropdownCommonWrapper">
                <SelectDropdownLabel
                  options={memberOptions?.length > 0 ? memberOptions : []}
                  value={memberOptions.find(
                    (option) => option.value === formik.values.tv_user_id
                  )}
                  setSelectedOption={(selectedOption) =>
                    formik.setFieldValue("tv_user_id", selectedOption?.value)
                  }
                  name="Select User"
                />
              </div>

              {formik.touched.tv_user_id && formik.errors.tv_user_id ? (
                <div className="error-message">{formik.errors.tv_user_id}</div>
              ) : null}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default TvUpdateForm;

// <div className="formInputBox">
// <Select
//   options={gymsData?.length > 0 ? gymsData : []}
//   value={formik?.values?.gym_id}
//   onChange={(selectedOption) => {
//     formik.handleChange("gym_id")(selectedOption.value);
//   }}
//   name="gym_id"
// />

// {formik.touched.tv_user_id && formik.errors.tv_user_id ? (
//   <div className="error-message">{formik.errors.tv_user_id}</div>
// ) : null}
// </div>

// <SelectDropdownLabel
// options={memberOptions?.length > 0 ? memberOptions : []}
// selectedOption={memberOptions.find(
//   (option) => option.value === formik?.values?.tv_user_id
// )}
// setSelectedOption={(selectedValue) =>
//   formik.setFieldValue("tv_user_id", selectedValue?.value)
// }
// name="Select User"
// />
